import { Directive, ElementRef } from '@angular/core';

@Directive({
    selector: '[ellipsisTooltip]',
    exportAs: 'ellipsisTooltip',
})
export class EllipsisTooltipDirective {
    constructor(private _elementRef: ElementRef<HTMLElement>) { }

    get isEllipsis(): boolean {
        const el = this._elementRef.nativeElement;
        if (!el) {
            return false;
        }
        return el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight;
    }
}
